import React from "react";
import brochure from "../../assets/icons/brochure.svg";
import indexCard from "../../assets/icons/indexCard.svg";
import form from "../../assets/icons/form.svg";
import videoLibrary from "../../assets/icons/videoLibrary.svg";
import { SendActionType } from "../shared/Services/SharedServices";
import { Auth0UserSerializer } from "../../recoil/types";
import { ResourceDownloadItem } from "./ResourceDownloadItem";
import brochureEn from "../../assets/files/BTO-UNITY-Complete-Brochure-Clinician-Web.pdf";
import requisitionForm from "../../assets/files/BTO-Unity-Complete-Requisition-Form.pdf";
import unityEn from "../../assets/files/BTO-UNITY-Patient-Rack-Card-EN.pdf";
import unityEs from "../../assets/files/BTO-UNITY-Patient-Rack-Card-ES.pdf";
import untiyCompleteEn from "../../assets/files/BTO-UNITY-Complete-Patient-Rack-Card-EN-Web.pdf";
import unityCompleteEs from "../../assets/files/BTO-UNITY-Complete-Patient-Rack-Card-ES-Web.pdf";
import formEn from "../../assets/files/Affordability_eng.pdf";
import formEs from "../../assets/files/Affordability_esp.pdf";

export const ResourcesData = (
  auth: Auth0UserSerializer | undefined,
  setLoggedOut: (inactivity: boolean) => void,
): JSX.Element[] => [
  <ResourceDownloadItem
    key="physician-brochure"
    alt="Brochure"
    icon={brochure}
    title="Clinician brochure"
    links={[
      {
        label: "English",
        link: brochureEn,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="index-card"
    alt="Index Card"
    icon={indexCard}
    title="Unity™ Index Card"
    links={[
      {
        label: "English",
        link: unityEn,
        linkInNewWindow: true,
        isDownload: true,
      },
      {
        label: "Español",
        link: unityEs,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="complete-index"
    alt="Index Card"
    icon={indexCard}
    title={
      <>
        Unity Complete<sup>&reg;</sup> Index Card
      </>
    }
    links={[
      {
        label: "English",
        link: untiyCompleteEn,
        linkInNewWindow: true,
        isDownload: true,
      },
      {
        label: "Español",
        link: unityCompleteEs,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="financial-form"
    alt="Form"
    icon={form}
    title="Affordibility Form"
    links={[
      {
        label: "English",
        link: formEn,
        linkInNewWindow: true,
        isDownload: true,
      },
      {
        label: "Español",
        link: formEs,
        linkInNewWindow: true,
        isDownload: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="requisition-form"
    alt="Requisition-Form"
    icon={brochure}
    title="Requisition Form"
    links={[
      {
        label: "English",
        link: requisitionForm,
        externalLink: true,
        linkInNewWindow: true,
      },
    ]}
  />,
  <ResourceDownloadItem
    key="video-library"
    alt="Video Library"
    contentType="(Online)"
    icon={videoLibrary}
    title="Video Library"
    links={[
      {
        label: "Browse Videos",
        link: "/provider/videos",
        onClick: () => {
          if (auth?.token) {
            SendActionType(
              "VideoLibraryLinkClicked",
              () => setLoggedOut(false),
              auth.token,
            );
          }
        },
      },
    ]}
  />,
];
